import { getColorToken, rem, getFontTokenStyle, marginBottomSpacing } from '@koaly/mixins';
import React from 'react';
import styled, { css } from 'styled-components';

const IconContainer = styled.div `
  display: flex;
  align-items: center;
  margin-bottom: auto;
  color: ${getColorToken('600', 'primary')};
  ${({ position, theme }) => position === 'left' &&
    css `
      margin-right: ${rem(12)};
    `} ${({ position }) => position === 'right' &&
    css `
      margin-left: auto;
    `}
`;
const ListItemBaseLi = styled.li `
  ${({ size, variant }) => getFontTokenStyle('label', size, variant)};
  display: inline-flex;
  flex-direction: row;
  align-items: flex-start;
  ${({ spaceAfter }) => spaceAfter && marginBottomSpacing(spaceAfter)};

  &:last-child,
  &:last-of-type {
    margin: 0;
  }
`;
ListItemBaseLi.defaultProps = {
    size: 'medium',
    variant: 'primary',
};
const ListItemBaseInnerWrapper = (props) => {
    const { children, prefixIcon, suffixIcon } = props;
    return (React.createElement(React.Fragment, null,
        prefixIcon && React.createElement(IconContainer, { position: "left" }, prefixIcon),
        children,
        suffixIcon && React.createElement(IconContainer, { position: "right" }, suffixIcon)));
};

export { ListItemBaseInnerWrapper, ListItemBaseLi };
//# sourceMappingURL=ListItemBase.js.map
